import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AfricaMapComponent } from '../africa-map/africa-map';

interface AboutTag {
  label: string;
  color: string;
  borderColor: string;
}

@Component({
  selector: 'app-about-section',
  standalone: true,
  imports: [TranslocoModule, AfricaMapComponent],
  templateUrl: './about-section.html',
  styles: [`:host { display: block; }`],
})
export class AboutSectionComponent {
  aboutTags: AboutTag[] = [
    { label: 'East Africa',         color: '#00D4FF', borderColor: 'rgba(0,212,255,0.22)' },
    { label: 'Real-time Tracking',  color: '#008CF0', borderColor: 'rgba(0,140,240,0.22)' },
    { label: 'Freight Marketplace', color: '#00D4FF', borderColor: 'rgba(0,212,255,0.22)' },
    { label: 'Fleet Management',    color: '#008CF0', borderColor: 'rgba(0,140,240,0.22)' },
  ];
}
